/** A mesma regra do servidor (server/src/lib/password.ts). */
export const MIN_PASSWORD_LENGTH = 8;

/** Tamanho da senha gerada: ~70 bits com o alfabeto abaixo. */
const GENERATED_LENGTH = 12;

// Sem os caracteres que se confundem ao ler e digitar: 0/O, 1/l/I.
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const DIGITS = '23456789';
const ALL = UPPER + LOWER + DIGITS;

/** Tamanho, ao menos uma letra e um número — o que o servidor exige. */
export const isStrongPassword = (value: string) =>
  value.length >= MIN_PASSWORD_LENGTH && /[a-zA-Z]/.test(value) && /\d/.test(value);

/** Inteiro uniforme em [0, max) do gerador criptográfico, sem o viés do módulo. */
function randomIndex(max: number): number {
  const limit = Math.floor(0x1_0000_0000 / max) * max;
  const buffer = new Uint32Array(1);
  do {
    crypto.getRandomValues(buffer);
  } while (buffer[0]! >= limit);
  return buffer[0]! % max;
}

const pick = (chars: string) => chars[randomIndex(chars.length)]!;

/**
 * Senha aleatória para o administrador passar ao membro: sempre com
 * maiúscula, minúscula e número, e sem caractere ambíguo.
 */
export function generatePassword(length = GENERATED_LENGTH): string {
  const chars = [pick(UPPER), pick(LOWER), pick(DIGITS)];
  while (chars.length < length) chars.push(pick(ALL));
  // Fisher–Yates: as três garantidas não ficam sempre no começo.
  for (let index = chars.length - 1; index > 0; index -= 1) {
    const swap = randomIndex(index + 1);
    [chars[index], chars[swap]] = [chars[swap]!, chars[index]!];
  }
  return chars.join('');
}
